// frontend/src/modules/Properties/constants/features.ts

export const PROPERTY_FEATURES = {
  property: [
  // ===== ТОП ПОПУЛЯРНЫЕ (встречаются в 70-100% объектов) =====
  'wifi',
  'airConditioning',
  'privatePool',
  'sharedPool',
  'tv',
  'furnished',
  'balcony',
  'shower',
  'washer',
  'refrigerator',
  'microwave',
  
  // ===== ОЧЕНЬ ПОПУЛЯРНЫЕ (встречаются в 50-70% объектов) =====
  'smartTV',
  'highSpeedInternet',
  'bathtub',
  'westernKitchen',
  'openKitchen',
  'waterHeater',
  'ensuiteBathroom',
  'guestRoom',
  'childFriendly',
  'petFriendly',
  'securitySystem',
  'cctv',
  'readyToMove',
  'infinityPool',
  'kidPool',
  
  // ===== ПОПУЛЯРНЫЕ (встречаются в 30-50% объектов) =====
  'jacuzzi',
  'openPlan',
  'separateShower',
  'centralAC',
  'fullyEquipped',
  'partiallyFurnished',
  'smartHome',
  'waterFiltration',
  'dryer',
  'dishwasher',
  'oven',
  'stove',
  'electricStove',
  'coffeemaker',
  'fiberOptic',
  'alarmSystem',
  'intercom',
  'videoIntercom',
  'soundproofing',
  'modernDesign',
  'highCeiling',
  'largeWindows',
  
  // ===== СРЕДНЕ ПОПУЛЯРНЫЕ (встречаются в 15-30% объектов) =====
  'privateGym',
  'privateSauna',
  'study',
  'kidsRoom',
  'closedKitchen',
  'thaiKitchen',
  'sharedBathroom',
  'elevator',
  'walkinCloset',
  'builtinWardrobe',
  'heating',
  'floorHeating',
  'solarWaterHeater',
  'gasStove',
  'inductionStove',
  'waterDispenser',
  'satelliteTV',
  'euroRenovation',
  'designerRenovation',
  'luxury',
  'penthouseLevel',
  'groundFloor',
  'topFloor',
  'newConstruction',
  'wheelchair',
  'disabledAccess',
  'energyEfficient',
  'multiLevel',
  'studio',
  
  // ===== МЕНЕЕ ПОПУЛЯРНЫЕ (встречаются в 7-15% объектов) =====
  'mediaRoom',
  'gameRoom',
  'billiardRoom',
  'nursery',
  'serviceRoom',
  'utilityRoom',
  'pantry',
  'wetRoom',
  'powderRoom',
  'outdoorBathroom',
  'steamRoom',
  'massage',
  'yogaRoom',
  'meditationRoom',
  'homeElevator',
  'cornerUnit',
  'maidsQuarters',
  'duplex',
  'triplex',
  'fireplace',
  'solarPanels',
  'generator',
  'ups',
  'floorToFloorWindows',
  'separateEntrance',
  'privateEntrance',
  'airPurifier',
  'surround',
  'homeTheater',
  'musicSystem',
  'traditionalStyle',
  'minimalist',
  'ramp',
  'emergencyExit',
  'fireExtinguisher',
  'firstAidKit',
  'smokeDetector',
  'carbonMonoxide',
  'eco',
  'sustainable',
  'greenBuilding',
  'leed',
  'underConstruction',
  'offPlan',
  'resale',
  
  // ===== РЕДКИЕ / ЭКСКЛЮЗИВНЫЕ (встречаются в <7% объектов) =====
  'privateLift',
  'library',
  'winecellar',
  'hammam',
  'artStudio',
  'workshop',
  'safebox',
  'telephone',
  'piano'
],

outdoor: [
  // ===== ТОП ПОПУЛЯРНЫЕ для Таиланда (встречаются в 70-100% объектов) =====
  'coveredParking',
  'openParking',
  'terrace',
  'garden',
  'outdoorShower',
  'bbqArea',
  'fence',
  'gate',
  
  // ===== ОЧЕНЬ ПОПУЛЯРНЫЕ (встречаются в 50-70% объектов) =====
  'garage',
  'carport',
  'privateGarden',
  'landscaped',
  'tropicalGarden',
  'outdoorDining',
  'sunbeds',
  'electricGate',
  'securityGate',
  'driveway',
  'pavedDriveway',
  'gardenLighting',
  'securityLighting',
  'storageRoom',
  
  // ===== ПОПУЛЯРНЫЕ (встречаются в 30-50% объектов) =====
  'rooftop',
  'rooftopTerrace',
  'sunshade',
  'pergola',
  'gazebo',
  'secureParking',
  'guestParking',
  'poolBar',
  'wall',
  'streetLighting',
  'sprinklerSystem',
  'waterTank',
  'drainageSystem',
  'laundryRoom',
  'dryingArea',
  'beachShower',
  'lounge',
  
  // ===== СРЕДНЕ ПОПУЛЯРНЫЕ (встречаются в 15-30% объектов) =====
  'outdoorKitchen',
  'summerKitchen',
  'pavilion',
  'bikestorage',
  'electricCarCharger',
  'fountain',
  'playground',
  'petArea',
  'shed',
  'automaticSprinklers',
  'irrigationSystem',
  'waterPump',
  'septicTank',
  'sewageSystem',
  'gravelDriveway',
  'decorativeLighting',
  'fruitTrees',
  'flowerGarden',
  
  // ===== МЕНЕЕ ПОПУЛЯРНЫЕ (встречаются в 7-15% объектов) =====
  'skyGarden',
  'pond',
  'koiPond',
  'swingSet',
  'slide',
  'sandbox',
  'dogRun',
  'petShower',
  'greenhouse',
  'outdoorGym',
  'sportsArea',
  'beachAccess',
  'drip',
  'rainwaterCollection',
  'well',
  'borehole',
  'japaneseGarden',
  'vegetableGarden',
  'trampoline',
  'walkingPath',
  'waterfall',
  
  // ===== РЕДКИЕ (встречаются в 3-7% объектов) =====
  'streambed',
  'tennisCourt',
  'basketballCourt',
  'footballField',
  'volleyball',
  'badminton',
  'puttingGreen',
  'bocce',
  'joggingTrack',
  'cyclingPath',
  'privateBeach',
  'beachCabana',
  'fishingPier',
  'boatDock',
  
  // ===== ОЧЕНЬ РЕДКИЕ / ЭКСКЛЮЗИВНЫЕ (встречаются в <3% объектов) =====
  'skatepark',
  'marina'
],
rental: [
  // ===== ТОП ПОПУЛЯРНЫЕ для Таиланда (встречаются в 70-100% объектов) =====
  'wifiIncluded',
  'internetIncluded',
  'maidService',
  'cleaning',
  'weeklyCleaning',
  'airportTransfer',
  'poolMaintenance',
  'gardenMaintenance',
  'maintenance',
  'shortTermRental',
  'longTermRental',
  'depositRequired',
  
  // ===== ОЧЕНЬ ПОПУЛЯРНЫЕ (встречаются в 50-70% объектов) =====
  'dailyCleaning',
  'utilitiesIncluded',
  'electricityIncluded',
  'waterIncluded',
  'linenChange',
  'towelChange',
  'laundryService',
  '24hSecurity',
  'securityGuard',
  'propertyManagement',
  'management',
  'repairService',
  'monthlyRental',
  'weeklyRental',
  'dailyRental',
  'flexibleCheckIn',
  'onlinePayment',
  'bankTransfer',
  
  // ===== ПОПУЛЯРНЫЕ (встречаются в 30-50% объектов) =====
  'scooterRental',
  'carRental',
  'bicycleRental',
  'massageService',
  'conciergeService',
  'driverService',
  'wasteDisposal',
  'pestControl',
  'cableTv',
  'streamingServices',
  'lateCheckOut',
  'earlyCheckIn',
  'creditCardRequired',
  'cashPayment',
  'longStayDiscount',
  'seasonalDiscount',
  'noSmoking',
  'noPets',
  'familyFriendly',
  'kidfriendly',
  'petFriendly',
  
  // ===== СРЕДНЕ ПОПУЛЯРНЫЕ (встречаются в 15-30% объектов) =====
  'chefService',
  'privateChef',
  'breakfastIncluded',
  'tourBooking',
  'ticketBooking',
  'restaurantReservation',
  'spaBooking',
  'snorkeling',
  'divingEquipment',
  'fishing',
  'ironing',
  'dryClean',
  '24hConcierge',
  'grocery',
  'delivery',
  'packageReceiving',
  'carWash',
  'recycling',
  'discountAvailable',
  'earlyBooking',
  'lastMinute',
  'noParties',
  'quietHours',
  'adultsOnly',
  'infantFriendly',
  'teenagerFriendly',
  
  // ===== МЕНЕЕ ПОПУЛЯРНЫЕ (встречаются в 7-15% объектов) =====
  'cateringService',
  'boatRental',
  'kayakRental',
  'halfBoard',
  'fullBoard',
  'allInclusive',
  'gasIncluded',
  'personalTrainer',
  'yogaInstructor',
  'shopping',
  'courierService',
  'mailHandling',
  'carService',
  'surfingLessons',
  'jetski',
  'speedboat',
  'yachtCharter',
  'beautyService',
  'hairSalon',
  'nailSalon',
  'pilatesInstructor',
  'swimInstructor',
  'translation',
  'interpreter',
  'visaAssistance',
  'immigration',
  'relocation',
  'furnitureRental',
  'applianceRental',
  'noDeposit',
  'installmentPlan',
  'corporateRate',
  'groupRate',
  'smokingAllowed',
  'noiseCurfew',
  'minimumAge',
  
  // ===== РЕДКИЕ (встречаются в 3-7% объектов) =====
  'petCare',
  'petSitting',
  'dogWalking',
  'babysitting',
  'childcare',
  'eldercare',
  'medicalService',
  'nurseOnCall',
  'doctorOnCall',
  'ambulance',
  'pharmacy',
  'valetParking',
  'kitesurfing',
  'wakeboarding',
  'parasailing',
  'bananaBoat',
  'tennisCoach',
  'golfCoach',
  'eventPlanning',
  'partyPlanning',
  'weddingPlanning',
  'catering',
  'florist',
  'photographer',
  'videographer',
  'musician',
  'dj',
  'entertainer',
  'legalService',
  'lawyer',
  'notary',
  'accounting',
  'taxService',
  'insurance',
  'storage',
  'studentDiscount',
  'seniorDiscount',
  'militaryDiscount',
  
  // ===== ОЧЕНЬ РЕДКИЕ / ЭКСКЛЮЗИВНЫЕ (встречаются в <3% объектов) =====
  'helicopterService',
  'privatePlane',
  'limousineService'
],

location: [
  // ===== ТОП ПОПУЛЯРНЫЕ для Таиланда/Пхукета (встречаются в 70-100% объявлений) =====
  'beachAccess',
  'beachFront',
  'walkToBeach',
  'nearSupermarket',
  'nearConvenience',
  'nearRestaurant',
  'nearCafe',
  'quietArea',
  'safeArea',
  'lowCrime',
  
  // ===== ОЧЕНЬ ПОПУЛЯРНЫЕ (встречаются в 50-70% объявлений) =====
  'secondLine',
  'nearShops',
  'nearMall',
  'nearHospital',
  'nearClinic',
  'nearPharmacy',
  'nearAirport',
  'nearMainRoad',
  'nearBank',
  'nearAtm',
  'peacefulLocation',
  'residentialArea',
  'gatedCommunity',
  'secureComplex',
  'wellLit',
  'pavedRoad',
  'nearBar',
  
  // ===== ПОПУЛЯРНЫЕ (встречаются в 30-50% объявлений) =====
  'nearMarket',
  'nearSpa',
  'nearGym',
  'nearFitness',
  'nearYoga',
  'nearWellness',
  'nearTaxiStand',
  'nearBusStop',
  'nearPostOffice',
  'nearPolice',
  'nearSalon',
  'nearInternationalSchool',
  'nearSchool',
  'touristArea',
  'expatArea',
  'internationalCommunity',
  'privateCommunity',
  'coastal',
  'waterfront',
  'hillside',
  'seaview',
  'walkable',
  'lowTraffic',
  'streetParking',
  'newDevelopment',
  
  // ===== СРЕДНЕ ПОПУЛЯРНЫЕ (встречаются в 15-30% объявлений) =====
  'nearNightlife',
  'nearGolfCourse',
  'nearMarina',
  'nearTouristAttraction',
  'nearViewpoint',
  'nearDiveSite',
  'nearSnorkeling',
  'nearPark',
  'nearGarden',
  'nearMountain',
  'nearWaterfall',
  'nearKindergarten',
  'nearGovernment',
  'nearTemple',
  'nearCinema',
  'nearPlayground',
  'nearSurfSpot',
  'luxuryDevelopment',
  'establishedArea',
  'trendyArea',
  'commercialArea',
  'localArea',
  'mixedUse',
  'publicTransport',
  'bikeFriendly',
  'hilltop',
  'mountainside',
  'island',
  'peninsula',
  'nearHighway',
  'sideStreet',
  'neighborhood',
  'familyOriented',
  
  // ===== МЕНЕЕ ПОПУЛЯРНЫЕ (встречаются в 7-15% объявлений) =====
  'nearYachtClub',
  'nearTennisCourt',
  'nearBasketball',
  'nearFootball',
  'nearVolleyball',
  'nearUniversity',
  'nearBusTerminal',
  'nearVet',
  'nearPetShop',
  'nearMosque',
  'nearChurch',
  'nearForest',
  'nearLake',
  'nearRiver',
  'nearNationalPark',
  'nearNatureReserve',
  'nearZoo',
  'nearAquarium',
  'nearMuseum',
  'nearGallery',
  'nearTheater',
  'nearStadium',
  'nearSportsCenter',
  'nearLibrary',
  'nearLandmark',
  'nearHiking',
  'nearCycling',
  'nearJogging',
  'businessDistrict',
  'upAndComing',
  'cityCentre',
  'cityCenter',
  'downtown',
  'suburb',
  'urban',
  'inland',
  'valley',
  'mainland',
  'riverside',
  'lakeside',
  'forestEdge',
  'parkside',
  'greenBelt',
  'openSpace',
  'lowDensity',
  'highDensity',
  'masterPlanned',
  'transitOriented',
  'noThroughTraffic',
  'deadEnd',
  'culDeSac',
  'mainStreet',
  'communitySpirit',
  'professionalArea',
  
  // ===== РЕДКИЕ (встречаются в 3-7% объявлений) =====
  'nearSkatepark',
  'nearConcertHall',
  'nearBookstore',
  'nearSynagogue',
  'nearEmbassy',
  'nearFireStation',
  'nearMetro',
  'nearTrain',
  'historicDistrict',
  'culturalQuarter',
  'artDistrict',
  'entertainmentDistrict',
  'financialDistrict',
  'shoppingDistrict',
  'midtown',
  'uptown',
  'outskirts',
  'countryside',
  'rural',
  'metropolitan',
  'plateau',
  'liveworkPlay',
  'smartCity',
  'ecoVillage',
  'sustainableCommunity',
  'carDependent',
  'carFree',
  'pedestrianZone',
  'privateStreet',
  'dirtRoad',
  'darkAtNight',
  'studentArea',
  'retirementCommunity'
],

views: [
  // ===== ТОП ПОПУЛЯРНЫЕ для Таиланда/Пхукета (встречаются в 70-100% объявлений) =====
  'seaView',
  'oceanView',
  'poolView',
  'gardenView',
  'mountainView',
  'panoramicView',
  
  // ===== ОЧЕНЬ ПОПУЛЯРНЫЕ (встречаются в 50-70% объявлений) =====
  'beachView',
  'sunsetView',
  'partialSeaView',
  'hillView',
  'unobstructedView',
  'balconyView',
  'terraceView',
  'scenicView',
  'beautifulView',
  
  // ===== ПОПУЛЯРНЫЕ (встречаются в 30-50% объявлений) =====
  'bayView',
  'coastalView',
  'islandView',
  'sunriseView',
  'forestView',
  'spectacularView',
  'stunningView',
  'magnificentView',
  'clearView',
  'privateView',
  'rooftopView',
  'elevatedView',
  'facingSouth',
  'facingWest',
  
  // ===== СРЕДНЕ ПОПУЛЯРНЫЕ (встречаются в 15-30% объявлений) =====
  'glimpseOfSea',
  'distantSeaView',
  'parkView',
  '180View',
  'niceView',
  'pleasantView',
  'windowView',
  'floorToFloorView',
  'horizonView',
  'marinaView',
  'yachtView',
  'boatView',
  'facingEast',
  'facingNorth',
  'southwestView',
  'southeastView',
  
  // ===== МЕНЕЕ ПОПУЛЯРНЫЕ (встречаются в 7-15% объявлений) =====
  'cityView',
  'skylineView',
  'lakeView',
  'riverView',
  'waterfallView',
  'pondView',
  '360View',
  'breathtakingView',
  'groundLevelView',
  'courtyardView',
  'atriumView',
  'streetView',
  'templeView',
  'portView',
  'sharedView',
  'northeastView',
  'northwestView',
  
  // ===== РЕДКИЕ (встречаются в 3-7% объявлений) =====
  'volcanoView',
  'skylightView',
  'noView',
  'obstructedView',
  'limitedView',
  'interiorView',
  'roadView',
  'parkingView',
  'neighborView',
  'wallView',
  'buildingView',
  'roofView',
  'towerView',
  'bridgeView',
  'monumentView',
  'palaceView',
  'castleView',
  'stadiumView',
  'airportView',
  'shipView'
]
};